import { Link } from "react-router-dom";
import { Gift, ArrowRight, Sparkles, Clock } from "lucide-react";
import { BOOKS } from "@/lib/catalog";
import { useGiftOffer, isHolidayPrice, fmtPrice, endsInLabel } from "@/lib/giftOffer";

export default function GiftSeasonBanner() {
  const status = useGiftOffer();
  if (!status?.show) return null;
  const eyebrow = status.occasion?.label || "Gift season";
  const holiday = isHolidayPrice(status);

  return (
    <section className="max-w-7xl mx-auto px-6 sm:px-8 pt-16" data-testid="gift-season-banner">
      <div className="relative overflow-hidden border border-primary-gold/40 bg-[#14110a] fade-up">
        <div className="absolute inset-0 pointer-events-none opacity-60" style={{ background: "radial-gradient(60% 120% at 85% 50%, rgba(201,162,39,0.22), transparent 70%)" }} />
        <Sparkles className="absolute top-6 right-8 w-5 h-5 text-primary-gold/60 floaty" />
        <div className="relative grid md:grid-cols-12 gap-8 items-center p-8 sm:p-12">
          <div className="md:col-span-7">
            <p className="flex items-center gap-2 font-mono-ui text-xs uppercase tracking-[0.3em] text-primary-gold" data-testid="gift-season-occasion">
              <Gift className="w-4 h-4" /> {eyebrow}
            </p>
            <h2 className="font-serif-display text-4xl sm:text-5xl font-medium mt-4 leading-[1.05]">
              Give a book lover <span className="text-primary-gold italic">40 days of stories.</span>
            </h2>
            <p className="text-soft text-base mt-5 max-w-lg">
              All four Michael Leckie novels to read and listen to — with a printable gift card and your own message. No subscription.
            </p>
            {holiday && (
              <div className="flex items-baseline gap-3 mt-6" data-testid="gift-season-price">
                <span className="font-mono-ui text-[10px] uppercase tracking-[0.25em] bg-primary-gold text-[#0B0C10] px-2 py-1">Holiday price</span>
                <span className="font-serif-display text-4xl text-primary-gold">{fmtPrice(status.gift_price)}</span>
                <span className="text-soft line-through font-mono-ui text-sm">{fmtPrice(status.regular_price)}</span>
              </div>
            )}
            {holiday && status.occasion?.ends_at && endsInLabel(status.occasion.ends_at) && (
              <p className="flex items-center gap-2 mt-3 font-mono-ui text-xs uppercase tracking-[0.18em] text-[#e0982f]" data-testid="gift-season-countdown">
                <Clock className="w-4 h-4" /> {endsInLabel(status.occasion.ends_at)}
              </p>
            )}
            <Link to="/reader/gift" data-testid="gift-season-cta" className="btn-gold inline-flex items-center gap-2 mt-8 px-8 py-4 font-mono-ui text-xs uppercase tracking-[0.18em]">
              Give the E-Reader <ArrowRight className="w-4 h-4" />
            </Link>
          </div>
          <div className="md:col-span-5 hidden md:flex justify-center">
            <div className="relative h-64 w-80">
              {BOOKS.slice(0, 4).map((b, i) => (
                <img
                  key={b.id}
                  src={b.cover}
                  alt=""
                  className="absolute top-4 w-32 border border-white/10 shadow-[0_20px_50px_rgba(0,0,0,0.7)] transition-transform duration-500 hover:-translate-y-2"
                  style={{ left: `${i * 56}px`, transform: `rotate(${(i - 1.5) * 6}deg)`, zIndex: i }}
                />
              ))}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
